<template>
  <v-btn :color="color" @click="toggleSidebar" flat>
    <v-icon>emoji_events</v-icon>
    <span class="ml-2">Ranking</span>
  </v-btn>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapMutations, mapState } = createNamespacedHelpers("matching");

export default {
  computed: {
    ...mapState(["showMatchRankingSidebar"]),
    color() {
      return this.showMatchRankingSidebar ? "blue" : "black";
    },
  },
  methods: {
    ...mapMutations(["setShowMatchRankingSidebar"]),
    toggleSidebar() {
      this.setShowMatchRankingSidebar(!this.showMatchRankingSidebar);
    },
  },
};
</script>